import axios from "axios";
import config from "../config";
import { getPwaToken } from "../context/Auth";
import {get} from "lodash";
const { ruleServerUrl, apiServerUrl } = config;

export const sendLink = (referFriend) => {
  return axios
    .post(`${ruleServerUrl}/referral/save`, referFriend)
    .then((response) => response.data)
    .catch((err) => {
      return err;
    });
};

export const sendLinkV2 = (referralDetails) => {
  console.log("ReferralDetails", referralDetails);
  const config = {
    headers: {
      Authorization: `Bearer ${getPwaToken()}`,
    }
  }

  return axios
    .post(`${apiServerUrl}/friend-referral`, referralDetails, config)
    .then((response) => response.data)
    .catch((err) => {
      return err;
    });
}

export const getConfig = (param, value) => {
  return axios
    .get(`${apiServerUrl}/friend-referral/config/?${param}=${value}`)
    .then((response) => response.data)
}

export const sendOtp = async (mobileNumber, tenantPayload, flowName = 'referral-otp') => {
    const url = `${ruleServerUrl}/flow-otp/generate-for/${flowName}/user-auth?token=${tenantPayload.token}`
    const response = await axios.post(url, {
        "mobile": mobileNumber,
        "tenantBrandBusinessId": null,
        "tenantId": null
    })
    return response.data;
}

export const verifyOtp = async (mobileNumber, tenantPayload, otp, flowName = 'referral-otp') => {
    const url = `${ruleServerUrl}/flow-otp/verify-for/${flowName}/user-auth?token=${tenantPayload.token}`
    const response = await axios.post(url, {
        "mobile": mobileNumber,
        "tenantBrandBusinessId": null,
        "tenantId": null,
        "otp": otp
    })
    return response.data;
}

export const shortenURL = async (token, urlToShorten) => {
    const url = `${ruleServerUrl}/shorten/referral-share-url`
    const response = await axios.post(url, {
        token,
        url: urlToShorten
    })
    return get(response.data, 'shortUrl', urlToShorten);
}
